import { lazy } from 'react';

export const BusinessEntitiesPage = lazy(() => import('./BusinessEntities/BusinessEntities'));

export const AdverseReactionTypesPage = lazy(
  () => import('./AdverseReactionTypes/AdverseReactionTypes')
);

export const AnimalSpeciesPage = lazy(() => import('./AnimalSpecies/AnimalSpecies'));

export const DrugAdministrationWaysPage = lazy(
  () => import('./DrugAdministrationWays/DrugAdministrationWays')
);

export const InformationSourcePage = lazy(() => import('./InformationSource/InformationSource'));

export const ManualChangesTypesPage = lazy(() => import('./ManualChangesTypes/ManualChangesTypes'));

export const SymptomsPage = lazy(() => import('./Symptoms/Symptoms'));

export const UnitsPage = lazy(() => import('./Units/Units'));

export const PharmGroupsPage = lazy(() => import('./PharmGroups/PharmGroups'));

export const SigningPersonPage = lazy(() => import('./SigningPerson/SigningPerson'));

export const FeedAdditiveTypesPage = lazy(() => import('./FeedAdditiveTypes/FeedAdditiveTypes'));

export const FeedAdditiveKindsPage = lazy(() => import('./FeedAdditiveKinds/FeedAdditiveKinds'));

export const ActiveSubstancesPage = lazy(() => import('./ActiveSubstances/ActiveSubstances'));

export const PharmReleasePage = lazy(() => import('./PharmRelease/PharmRelease'));

export const PharmPackagePage = lazy(() => import('./PharmPackage/PharmPackage'));

export const ActivityKindsPage = lazy(() => import('./ActivityKinds/ActivityKinds'));

export const GmoUseTypesPage = lazy(() => import('./GmoUseTypes/GmoUseTypes'));

export const GmoResearchTypesPage = lazy(() => import('./GmoResearchTypes/GmoResearchTypes'));

export const MeasuringUnitsPage = lazy(() => import('./MeasuringUnits/MeasuringUnits'));
